import GlpDataTable from './GlpDataTable.vue'

export { GlpDataTable }
